export default [
  {
    title: 'Inicio',
    icon: 'home',
    link: 'AccountDashboard',
    options: [],
    use: ['CL', 'PE']
  },
  {
    title: "Métricas",
    icon: "metrics",
    link: "MetricsList",
    use: ['CL', 'PE'],
    options: [
      {
        title: "Resumen emisión",
        link: "MetricsList",
        associatedRoutes: [],
        use: ['CL', 'PE']
      },
      {
        title: "Resumen recepción",
        link: "RecMetricsList",
        associatedRoutes: [''],
        use: ['CL', 'PE']
      },
      {
        title: "Ventas por tienda",
        link: "StoreSales",
        associatedRoutes: [''],
        permission: 'view_metrics_branches',
        use: ['CL', 'PE']
      },
      {
        title: "Ventas de la organización",
        link: "OrganizationSales",
        associatedRoutes: [''],
        permission: 'view_metrics_account',
        use: ['CL', 'PE']
      },
      {
        title: "Reporte de ventas",
        link: "SalesReport",
        associatedRoutes: [''],
        permission: 'view_metrics_account',
        use: ['PE']
      }
    ]
  },
  {
    title: "Emisión",
    icon: "document",
    link: "DocumentsList",
    use: ['CL', 'PE'],
    options: [
      {
        title: "Documentos",
        link: "DocumentsList",
        associatedRoutes: ["DocumentsCreate", "DocumentsRetrieve"],
        use: ['CL', 'PE']
      },
      {
        title: "Resúmenes",
        link: "SummariesList",
        associatedRoutes: ["SummariesRetrieve"],
        use: ['PE']
      },
      {
        title: "Emisión por lote",
        link: "DocumentsBatchListCreate",
        associatedRoutes: ["DocumentsBatchRetrieve"],
        use: ['CL', 'PE']
      },
      {
        title: "Cuadratura",
        link: "ReconciliationsListCreate",
        associatedRoutes: ["ReconciliationsRetrieve"],
        use: ['CL', 'PE']
      },
      {
        title: 'Clientes',
        link: 'CustomerListCreate',
        associatedRoutes: ['CustomerRetrieveUpdate'],
        use: ['CL', 'PE']
      },
      {
        title: 'Reportes',
        link: 'ReportsList',
        associatedRoutes: ['SireList', 'SalesReportDetail'],
        use: ['CL', 'PE']
        // permission: 'download_detvta' // CONFIRMAR: permiso de visibilidad de la sección Reportes (AXTDEV-356)
      }
    ]
  },
  {
    title: "Recepción",
    icon: "purchase",
    link: "PurchaseList",
    options: [
      {
        title: "Documentos",
        link: "PurchaseList",
        associatedRoutes: ["PurchaseRetrieve"],
        use: ['CL', 'PE']
      },
      {
        title: "Pendientes por recibir",
        link: "PendingReceiveList",
        associatedRoutes: ["PendingReceiveRetrieve"],
        accountOption: 'pending_documents',
        use: ['CL']
      },
      {
        title: "Proveedores",
        link: "SupplierListCreate",
        associatedRoutes: ["SupplierRetrieveUpdate"],
        accountOption: 'rec_process_rules',
        use: ['CL', 'PE'],
        permission: 'change_rules'
      },
      {
        title: "Categorías",
        link: "SuppliersCategoriesList",
        associatedRoutes: ["SuppliersCategoriesRetrieveUpdate"],
        accountOption: 'rec_process_rules',
        permission: 'change_rules',
        use: ['CL', 'PE']
      }
    ],
    associatedRoutes: ["PurchaseRetrieve"],
    use: ['CL', 'PE']
  },
  {
    title: "Tiendas",
    icon: "pos",
    options: [],
    link: "BranchListCreate",
    use: ['CL', 'PE']
  },
  {
    title: "Centro de ayuda",
    description: "",
    link: "",
    options: [],
    use: ['CL', 'PE']
  }
]
